var map = {
  "./km.json": [
    "160873",
    "218407"
  ],
  "./ru.json": [
    "769109",
    "696285"
  ],
  "./bg.json": [
    "512374",
    "210562"
  ],
  "./el.json": [
    "116156",
    "70927"
  ],
  "./en-pt.json": [
    "59042",
    "315333"
  ],
  "./ja.json": [
    "87389",
    "134867"
  ],
  "./ar.json": [
    "886610",
    "338816"
  ],
  "./rw.json": [
    "198211",
    "429438"
  ],
  "./sr.json": [
    "824264",
    "704152"
  ],
  "./lol.json": [
    "120119",
    "104094"
  ],
  "./fr.json": [
    "869463",
    "838731"
  ],
  "./sv.json": [
    "941836",
    "57827"
  ],
  "./as.json": [
    "630361",
    "305831"
  ],
  "./gu.json": [
    "734101",
    "483493"
  ],
  "./kk.json": [
    "810393",
    "845025"
  ],
  "./nb.json": [
    "193620",
    "372902"
  ],
  "./ta.json": [
    "513258",
    "637172"
  ],
  "./ky.json": [
    "311823",
    "589885"
  ],
  "./pl.json": [
    "598115",
    "796176"
  ],
  "./ro.json": [
    "837839",
    "700026"
  ],
  "./ka.json": [
    "96687",
    "932066"
  ],
  "./hu.json": [
    "745353",
    "125393"
  ],
  "./uk.json": [
    "803621",
    "42491"
  ],
  "./or.json": [
    "108341",
    "252014"
  ],
  "./uz.json": [
    "70889",
    "352849"
  ],
  "./hy.json": [
    "916024",
    "311249"
  ],
  "./de.json": [
    "103349",
    "384619"
  ],
  "./pt-pt.json": [
    "998822",
    "198423"
  ],
  "./vi.json": [
    "271772",
    "993053"
  ],
  "./tr.json": [
    "469168",
    "519315"
  ],
  "./da.json": [
    "153604",
    "982639"
  ],
  "./kn.json": [
    "184403",
    "198929"
  ],
  "./mr.json": [
    "718240",
    "38446"
  ],
  "./id.json": [
    "192646",
    "398427"
  ],
  "./lt.json": [
    "363456",
    "64555"
  ],
  "./lv.json": [
    "845561",
    "328056"
  ],
  "./fv.json": [
    "367121",
    "630262"
  ],
  "./zh-hans.json": [
    "547293",
    "638943"
  ],
  "./es.json": [
    "742347",
    "672548"
  ],
  "./ko.json": [
    "153176",
    "397121"
  ],
  "./te.json": [
    "870481",
    "286140"
  ],
  "./bn.json": [
    "184346",
    "180714"
  ],
  "./cs.json": [
    "658351",
    "634601"
  ],
  "./boxes.json": [
    "578884",
    "456910"
  ],
  "./my.json": [
    "761269",
    "64621"
  ],
  "./mn.json": [
    "399085",
    "469408"
  ],
  "./sk.json": [
    "475181",
    "981360"
  ],
  "./nl.json": [
    "229462",
    "363667"
  ],
  "./az.json": [
    "950380",
    "551991"
  ],
  "./accents.json": [
    "769390",
    "206833"
  ],
  "./pa.json": [
    "446986",
    "250878"
  ],
  "./pt.json": [
    "481626",
    "137081"
  ],
  "./extra.json": [
    "989095",
    "77899"
  ],
  "./it.json": [
    "818251",
    "169169"
  ],
  "./hi.json": [
    "367149",
    "288383"
  ]
};
function webpackAsyncContext(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1]).then(function() {
    return __webpack_require__.t(id, 3 | 16);
  });
}

webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 649445;
module.exports = webpackAsyncContext;
